import {
  girl,
  Customer2,
  burger,
  chowmin,
  roundFood,
} from '../assets/images/images';

export const productcards = [
  {
    title: 'Burger',
    image: burger,
    description: '+300 cakes varieties to choose',
    name: 'burger',
  },
  {
    title: 'Chowmin',
    image: chowmin,
    description: '+300 cakes varieties to choose',
    name: 'pasta',
  },
  {
    title: 'Food',
    image: roundFood,
    description: '+300 cakes varieties to choose',
    name: 'meatBalls',
  },
  {
    title: 'Burger',
    image: burger,
    description: '+300 cakes varieties to choose',
    name: 'pizza',
  },
  {
    title: 'Food',
    image: roundFood,
    description: '+300 cakes varieties to choose',
    name: 'burger',
  },
];
export const reviews = [
  {
    name: 'Smriti',
    image: girl,
    review:
      'Amet in elementum nulla scelerisque dui, egestas at. Elit consectetur turpis elementum amet vitae et etiam nec. Varius volutpat hac adipiscing tincidunt pretium.',
  },
  {
    name: 'ALia',
    image: Customer2,
    review:
      'Amet in elementum nulla scelerisque dui, egestas at. Elit consectetur turpis elementum amet vitae et etiam nec. Varius volutpat hac adipiscing tincidunt pretium.',
  },
];
